// extracted by mini-css-extract-plugin
export default {"container":"NoEvents_container__eR2ov","content":"NoEvents_content__awOv5","content__icon":"NoEvents_content__icon__vmkNd","content__txt":"NoEvents_content__txt__r1FRt"};